<template>
  <div style="display: flex;">
    <div class="main-content" :style="mainContentViewHeight" style="width: 80%;">
      <customForm
         v-if="customFormShow"
         ref="customFormRef"
         :baseURL.sync="baseURL"
      >
      </customForm>

      <customFormOther
              v-if="customFormOtherShow"
              ref="customFormOtherRef"
              nodeCode="GC00014"
      ></customFormOther>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>附件列表</span>
        </div>
        <template>
          <el-table
                  :data="tableData"
                  style="width: 100%">
            <el-table-column
                    prop="date"
                    label="日期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="姓名"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="地址">
            </el-table-column>
          </el-table>
        </template>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>数据见证记录(审批信息)</span>
        </div>
        <template>
          <el-table
                  :data="tableData"
                  style="width: 100%">
            <el-table-column
                    prop="date"
                    label="日期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="姓名"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="地址">
            </el-table-column>
          </el-table>
        </template>
      </el-card>

    </div>
    <div class="el-card box-card is-always-shadow" style="margin: 0 10px 0 10px;width: 20%;height: auto">
      <div style="text-align: center;margin:10px 0 3px 0">
          <!-- 这里图标改一下 -->
        <span @click="getFlowNode(0)"><icon-svg name="zonghe" class="site-sidebar__menu-icon"></icon-svg></span>
        <span @click="getFlowNode(1)"><icon-svg name="menu" class="site-sidebar__menu-icon"></icon-svg></span>
        <span @click="getFlowNode(2)"><icon-svg name="admin" class="site-sidebar__menu-icon"></icon-svg></span>
        <span @click="getFlowNode(3)"><icon-svg name="log" class="site-sidebar__menu-icon"></icon-svg></span>
        <span @click="getFlowNode(4)"><icon-svg name="role" class="site-sidebar__menu-icon"></icon-svg></span>
      </div>
      <div v-for="(value, key) in flowData" :key="key">
        <table style="border: 1px solid #6e6d6d;border-collapse:collapse;text-align: center">
          <tr style="height: 25px;background: #0259a8;color: white;"><td style="border: 1px solid #6e6d6d;width: 300px">{{key}}</td></tr>
          <tr v-for="item in value" :key="item.id" style="height: 25px;">
            <td v-if="item.isVisible" class="link" style="border: 1px solid #6e6d6d;width: 300px;color: #005aff" @click="getFormContent(item.formId)">{{item.nodeName}}</td>
            <td v-else style="border: 1px solid #6e6d6d;width: 300px;color: #8b8c9b">{{item.nodeName}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import customForm from '@/components/customForm';
  import customFormOther from '@/components/customForm/customFormOther';
  export default {
    components: {
      customForm,
      customFormOther
    },
    props: ["mainContentViewHeight"],
    data() {
      return {
        visible: false,
        customFormShow:true,
        customFormOtherShow:false,
        dataId: '',
        projectCode: '',
        paramMap: {
          tenderProjectCode: '',
          bidSectionCode: '',
          projectCode:''
        },
        busType:'',
        baseURL:'',
        tenderProjectCode: '',
        bidSectionCode: '',
        formId: '',
        groupList: [],
        formInfo:{},
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        flowData:''
      }
    },
    activated() {
      this.formId = this.$route.params.formId
      this.dataId = this.$route.params.id
      this.paramMap = this.$route.params.paramMap
      console.log(this.paramMap)
      this.projectCode = this.$route.params.paramMap.projectCode
      this.tenderProjectCode = this.$route.params.paramMap.tenderProjectCode
      this.bidSectionCode = this.$route.params.paramMap.bidSectionCode

      this.busType =  window.sessionStorage.getItem("busType");

      this.initData()
    },
    methods: {

      initData() {
        if (this.formId === undefined) {
          this.$message.error('数据集无效')
          return
        }

        this.$refs.customFormRef.getCustomData(this.formId,this.paramMap)
        this.getFlowNode(0)


      },
      // 获取数据列表
      getDataContent() {
        let url=`/customform/query/detail/${this.formId}`
        this.$http
            .post(this.$http.adornUrl(url), {paramMap: this.paramMap},{baseURL:'',})
            .then(({ data }) => {
              if (data) {
                this.groupList = data.data;
                this.formInfo=data.form
              } else {
                this.groupList = [];
                this.formInfo={}
              }
            });
      },
      getFlowNode(angleType) {
        this.$http({
          url: '/configs/sysFlowNodeConfig/bulidFlownodeTree?busType='+this.busType+"&angleType="+angleType,
          method: 'get'
        }).then(({data}) => {
          if (data) {
            this.flowData = data.data
          } else {
            this.flowData = ''
          }
        })
      },
      getFormContent(formId) {
        this.$http({
          url: this.$http.adornUrl(`/customform/query/list/${formId}`),
          method: 'post',
          baseURL: '',
          data: {
            'rows': 1,
            'filter':{'tenderProjectCode':this.tenderProjectCode,'bidSectionCode':this.bidSectionCode}
          }
        }).then(({data}) => {
          if (data) {

            this.$refs.customFormRef.getCustomData(formId,this.paramMap)

          }
        })
      },
      getFormContent2(item){

        this.$refs.customFormOtherRef.getCustomData(item.formId,this.paramMap);

      },

    }
  }
</script>


<style lang="less" scoped>
  .el-dialog__wrapper /deep/ .el-dialog__header{
  }
  .el-dialog__wrapper /deep/ .el-dialog__body{
    padding: 10px 20px;
  }
  .el-form /deep/ .el-form-item.single-row{
    width: 100%;
  }
  .el-form /deep/ .el-form-item{
    width: 50%;
    margin-bottom:0px;
  }
  .el-dialog__wrapper /deep/ .el-dialog__footer{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .link:hover {
    cursor: pointer; //鼠标变手
    background-color: #0284fd; //链接变颜色
    color: white!important;
  }
</style>
